import { j as i } from "./index.es33.js";
import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import "./index.es97.js";
import "./index.es98.js";
import "./index.es99.js";
import "./index.es100.js";
import "./index.es101.js";
import "./index.es102.js";
import "./index.es103.js";
import "./index.es104.js";
import { palette as r } from "./index.es36.js";
import { Icon as o } from "./index.es7.js";
import t from "./index.es653.js";
var N = function N(_ref) {
  var s = _ref.value,
    m = _ref.isClearable;
  return s && m ? i.jsx(o, {
    className: t.iconClear,
    color: r.gray6,
    size: 16,
    icon: o.icons.system.s.utilities.cross
  }) : i.jsx(o, {
    className: t.iconCalendar,
    color: r.gray6,
    size: 16,
    icon: o.icons.system.s.utilities.calendar
  });
};
export { N as CalendarIcon };